import React from 'react';
import { FilterOptionsState, createFilterOptions } from '@mui/material';

import { KeyValue, KeyValueDefault } from '@/main/models/common';
import { userIsAdmin, userIsInsurer } from '@/main/services/utilsUser';

import KogAutoCompleteControlled from './autoCompleteControlled';

const GENERIC_VALUE = 'Generico';

const defaultFilter = createFilterOptions<KeyValue | KeyValueDefault>();

type Props = React.ComponentProps<typeof KogAutoCompleteControlled>;

function KogAutoCompleteVehicleControlled(props: Props) {
  const canUseGenericFallback = userIsAdmin() || userIsInsurer();

  const filterOptionsWithGenericFallback = (
    opts: (KeyValue | KeyValueDefault)[],
    state: FilterOptionsState<KeyValue | KeyValueDefault>
  ) => {
    const filtered = defaultFilter(opts, state);
    if (filtered.length > 0 || !canUseGenericFallback) return filtered;

    const generic = opts.find(
      opt => 'value' in opt && opt.value === GENERIC_VALUE
    );
    return generic ? [generic] : filtered;
  };

  return (
    <KogAutoCompleteControlled
      {...props}
      filterOptions={filterOptionsWithGenericFallback}
    />
  );
}

export default KogAutoCompleteVehicleControlled;
